import React from 'react';

export const ListaUsu = () => {
	return [
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '633333333',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan Antonio',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '644444444',
			codPostUsuario: '10232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Roberto',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '655555555',
			codPostUsuario: '10232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Alberto',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '666666666',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juasdfn',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '633333333',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juasdfan Antonio',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '644444444',
			codPostUsuario: '10232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Roberdfdffto',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '655555555',
			codPostUsuario: '10232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Albddddferto',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '666666666',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Jerduan',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '633333333',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Jdfwguan Antonio',
			idUsuario: '74320985',
			direccionUsuario: 'C/ Santa lucia 14',
			telefonoUsuario: '644444asdf444',
			codPostUsuario: '10asf232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Robasdferseto',
			idUsuario: '74320sdf985',
			direccionUsuario: 'C/ Saafnta lucia 14',
			telefonoUsuario: '6555555333',
			codPostUsuario: '1d0232',
			ShareCare: 'No activo',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Albeasdfrwefwefto',
			idUsuario: '7432df985',
			direccionUsuario: 'C/ Santa lucddia 14',
			telefonoUsuario: '666666366',
			codPostUsuario: '10232',
			ShareCare: 'Activo',
		},
	];
};
